export default __webpack_public_path__ + "static/media/assignments-completed.85a1dcf5.svg";